var React = require('react');

function StepCircle0148px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-.533 32h2.21V15.1h-1.95l-3.692 1.976.442 1.742 2.938-1.586h.052V32z"}));
}

StepCircle0148px.displayName = "StepCircle0148px";

StepCircle0148px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0148px;

StepCircle0148px.default = StepCircle0148px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-01-48px.svg
// module id = 1152
// module chunks = 0